export class CsrDetalhe{
    id: number;
    nome: string;
    email: string;
    cpf: string;
    rg: string;
	rgOrgaoExpedidor: string;
	rgUf: string;
	telefone: string;
	profissao: string;
    dataNascimento: string;
}